import { render, staticRenderFns } from "./storeSelect.vue?vue&type=template&id=061ff0ed&scoped=true"
import script from "./storeSelect.vue?vue&type=script&lang=js"
export * from "./storeSelect.vue?vue&type=script&lang=js"
import style0 from "./storeSelect.vue?vue&type=style&index=0&id=061ff0ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ff0ed",
  null
  
)

export default component.exports